import '../DocumentationPages.css';
const VisualDatasetInfoView = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div
        id="user_guide"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: '88%',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              backgroundColor: '#CEDBD6',
              backgroundSize: 'cover',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              padding: '35px 15% 35px 10%',
            }}
          >
            <h4>Visualize multiple datasets on a map</h4>You can easily explore
            and visualize datasets on an interactive map.
            <ol>
              <li>
                <strong>Explore the Catalog:</strong> Navigate to the Data
                Catalog tab to browse through available datasets.
              </li>
              <li>
                <strong>Search and Filter Data:</strong> Use the search input
                field in the catalog to find specific datasets. You can also
                filter the data by Data Collection to narrow down your search.
              </li>
              <li>
                <strong>Add Datasets to Map Viewer:</strong> For each dataset
                you want to visualize, click the button that says{' '}
                <strong>"Add to Map Viewer"</strong>.
              </li>
              <li>
                <strong>View Data in Map Viewer:</strong> Switch to the Map
                Viewer tab, where you’ll see your selected datasets visualized
                on the map as separate data layers.
              </li>
              <li>
                <strong>Control Dataset Layers:</strong> Each dataset appears as
                a layer in the right sidebar. You can adjust the{' '}
                <strong>opacity</strong> and toggle layers on or off by checking
                or unchecking the boxes to refine the visualization and focus on
                specific data.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};
const DownloadMapInfoView = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div
        id="user_guide"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: '88%',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              backgroundColor: '#CEDBD6',
              backgroundSize: 'cover',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              padding: '35px 15% 35px 11.5%',
            }}
          >
            <h4>Download individual data cropped to specific boundaries</h4>
            This feature allows you to download data for specific areas,
            customized to your needs. Follow these steps:{' '}
            <ol>
              <li>
                <strong>Download Dataset Layers:</strong> In the Map Viewer tab,
                you’ll find a download button for each dataset layer. Click the{' '}
                <strong>Download</strong> button for the dataset you want to
                download.
              </li>
              <li>
                <strong>Select Boundaries:</strong> Choose the type of boundary
                you want to use from the dropdown list.
              </li>
              <li>
                <strong>Select Region:</strong> After selecting a boundary type,
                pick the specific region from the boundary dataset.
              </li>
              <li>
                <strong>Download Data:</strong> Once the region is selected,
                click <strong>Download</strong> to receive the cropped dataset.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};
const ITSReportInfoView = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div
        id="user_guide"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: '88%',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              backgroundColor: '#CEDBD6',
              backgroundSize: 'cover',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              padding: '35px 15% 35px 10%',
            }}
          >
            <h4>Generate a report for ITS dataset</h4>
            <ol>
              <li>
                In the Map Viewer tab, you’ll find a download button for each
                dataset layer. Click the <strong>Reports</strong> button for the
                dataset you want to download.
              </li>
              <li>
                <strong>Select Boundaries:</strong> Choose the type of boundary
                you want to use from the dropdown list.
              </li>
              <li>
                <strong>Select Region:</strong> After selecting a boundary type,
                pick the specific region from the boundary dataset.
              </li>{' '}
              <li>
                <strong> Select Boundaries:</strong> Choose the type of boundary
                you want to use from the dropdown list.
              </li>
              <li>
                <strong> Select Output Format: </strong>
                <ul>
                  <li>
                    The report will be a summary report containing an overview
                    and analysis of the treatment within the region.
                  </li>
                </ul>
              </li>
            </ol>
            <hr />
            <h4>Integrate Our Services for Third-Party Applications</h4>Easily
            integrate the services into third-party applications with WMS and
            WFS support. Here’s how to access the necessary URLs:
            <ol>
              <li>
                <strong>Search in the Catalog:</strong> Go to the Catalog tab
                and search for the dataset you want to integrate.
              </li>
              <li>
                <strong>Access Service URLs:</strong> Click the{' '}
                <strong>Services</strong> button in your desired dataset result.
              </li>{' '}
              <li>
                <strong>Find WMS/WFS URLs:</strong> Here, you’ll find the WMS
                and WFS URLs. More detailed information on how to integrate
                these into your mapping tools can be found by following this
                integration guide.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};
export { ITSReportInfoView, DownloadMapInfoView, VisualDatasetInfoView };
